import { platformOptions, SOURCE_PLATFORM_TYPE } from '@/entities/public-filter';
import { TooltipFlat } from '@/shared/components/shadcn/tooltip/tooltip-flat';
import { cn } from '@/shared/utils';

type Props = {
  onPlatformChange: (platform: SOURCE_PLATFORM_TYPE) => void;
  isLoading: boolean;
  values: SOURCE_PLATFORM_TYPE[];
};

export const PlatformSelector = ({ onPlatformChange, isLoading, values }: Props) => {
  return (
    <div className="flex items-center gap-3">
      {platformOptions.map((platform) => {
        const Logo = platform.icon || (() => null);
        const button = (
          <button
            onClick={() => onPlatformChange(platform.value)}
            disabled={isLoading || platform.creator_search_disabled}
            className={cn(
              'flex cursor-pointer items-center gap-2 rounded-md border border-transparent px-2 py-1.5 text-sm font-medium transition-colors',
              values?.includes(platform.value)
                ? 'border-primary bg-muted text-popover-foreground'
                : 'bg-muted text-popover-foreground',
              (isLoading || platform.creator_search_disabled) && 'opacity-50',
            )}
          >
            <Logo className="size-4" />
            {platform.label}
          </button>
        );

        if (!platform.creator_search_disabled) {
          return <div key={platform.value}>{button}</div>;
        }

        return (
          <TooltipFlat key={platform.value} asChild content="Coming soon">
            {button}
          </TooltipFlat>
        );
      })}
    </div>
  );
};
